export default function UploadDocumentDialogController(
  $q,
  $timeout,

  ssDialogService,
  loaderService,
  alerts,
  docDataService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleValidateFileAsync = _handleValidateFileAsync;
  vm.handleFileAdd = _handleFileAdd;
  vm.handleFormSubmit = _handleFormSubmit;

  vm.customerId = vm.customerId || 0;
  vm.parentFolderId = vm.parentFolderId || 0;
  vm.parentFolder = vm.parentFolder || null;
  vm.documentId = vm.documentId || -1;
  vm.files = vm.files || [];
  vm.uploadProgress = 0;
  vm.validatedFileNames = [];

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.global.uploadDocumentDialog);
  }

  function _handleValidateFileAsync($file, form) {
    const dfdDocumentExists = $q.defer();
    docDataService.documentExists(vm.customerId, vm.parentFolderId, vm.documentId, $file.name).then(
      (documentExistsResponse) => {
        if (documentExistsResponse.data.result && !vm.validatedFileNames.includes($file.name)) {
          alerts.error(`File already exists with the filename "${$file.name}".
            Duplicate filenames not allowed within a directory.`);
          $timeout(() => { _removeDocumentByName($file.name, form); }, 0);
        }
        dfdDocumentExists.resolve(!documentExistsResponse.data.result);
      }
    );
    return dfdDocumentExists.promise;
  }

  function _removeDocumentByName(fileName, form) {
    vm.validatedFileNames.push(fileName);
    vm.files = vm.files.filter(file => file.name !== fileName);
    if (vm.files && vm.files.length > 0) {
      form.uploadFiles.$setValidity('required', true);
    } else {
      form.uploadFiles.$setValidity('required', false);
    }
  }

  // eslint-disable-next-line no-unused-vars
  function _handleFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.uploadProgress = 0;
    vm.validatedFileNames = [];
  }

  function _handleFormSubmit(form) {
    const dfdSave = $q.defer();
    if (form.$valid) {
      loaderService.showViewLoader = true;
      docDataService.saveDocuments(vm.customerId, vm.serviceId, vm.parentFolderId, vm.files)
        .then((response) => {
          if (response.status === 201 || response.status === 200) {
            if (response.data[0].documentId > 0) {
              alerts.success('File(s) uploaded successfully.');
              if (vm.updateCallback) {
                vm.updateCallback(vm.parentFolder, response.data);
              }
              _handleCloseDialogClick();
            } else {
              alerts.error('Error occurred while saving file(s).');
            }
            dfdSave.resolve();
          } else {
            alerts.error('Error occurred while uploading file(s).');
            dfdSave.reject();
          }
        }, (response) => {
          if (response.status > 0) {
            alerts.error('Error occurred while uploading file(s).');
          }
        }, (event) => {
          vm.uploadProgress = Math.min(100, parseInt(100.0 * event.loaded / event.total, 10));
        }).finally(() => {
          loaderService.showViewLoader = false;
        });
    } else {
      dfdSave.reject();
    }

    return dfdSave.promise;
  }
}

UploadDocumentDialogController.$inject = [
  '$q',
  '$timeout',

  'ssDialogService',
  'loaderService',
  'alerts',
  'docDataService'
];
